/** Namespace `shell` — khung app: sidebar, thanh đầu trang, cổng phiên, ô tìm danh mục, nút theme / ngôn ngữ. */
export const shell = {
  menuBack: "Quay lại",
  menuClose: "Đóng menu con",
  menuExpand: "Mở nhóm",
  navigation: "Điều hướng chính",
  configuration: "Thiết lập tích hợp",
  skipContent: "Đến nội dung chính",
  openMenu: "Mở hoặc thu gọn menu",
  preferences: "Tùy chọn",
  changePassword: "Đổi mật khẩu",
  "group.integrations": "Tích hợp",
  "nav.providers": "Nhà cung cấp",
  "nav.integrationAccounts": "Tài khoản nền tảng",
  "nav.integrationConnections": "Kết nối",
  "nav.integrationBindings": "Gán cho ứng dụng",
  "nav.integrationRouting": "Tuyến gửi email",
  "nav.integrationEntitlements": "Quyền sử dụng & thương mại",
  "nav.featureReadiness": "Độ sẵn sàng tính năng",
  "nav.integrationHealth": "Tình trạng tích hợp",
  "nav.labTingee": "Tingee",
  "nav.labBankHub": "Bank Hub",
  "nav.labEinvoice": "Hoá đơn điện tử",
  "group.general": "Hỗ trợ khách hàng",
  "group.lab": "Phòng thử",
  "group.metrics": "Kinh doanh",
  "group.metricsHint": "Mọi app — chọn từng app trong trang",
  "group.apps": "Ứng dụng",
  "group.system": "Vận hành hệ thống",
  "group.admin": "Nội bộ",

  "nav.attention": "Cần xử lý",
  "nav.support": "Hỗ trợ",
  "nav.overview": "Tổng quan",
  "nav.integrations": "Tích hợp",
  "nav.ai": "AI",
  "nav.labIndex": "Danh sách phòng thử",
  "nav.labFixtures": "Dữ liệu thử",
  "nav.labRuns": "Lịch sử thử",
  "nav.audience": "Người dùng",
  "nav.subscriptions": "Gói đăng ký",
  "nav.revenue": "Doanh thu",
  "nav.planMapping": "Ánh xạ gói",
  "nav.feedback": "Phản hồi",
  "nav.sources": "Nguồn dữ liệu",
  "nav.reliability": "Độ tin cậy",
  "nav.cost": "Chi phí hạ tầng",
  "nav.mailStatus": "Vận hành email",
  "nav.mailProviders": "Tài khoản gửi email",
  "nav.dependencies": "Sơ đồ phụ thuộc",
  "nav.products": "Danh mục sản phẩm",
  "nav.ops": "Lịch sử thu thập",
  "nav.staff": "Nhân viên",
  "nav.teams": "Đội ngũ",
  "nav.ownership": "Phân công phụ trách",
  "nav.appHome": "Tổng quan app",
  "nav.shopBankTransfer": "Xác nhận chuyển khoản",
  "nav.sharedHub": "Bube Bank Transfer Hub",
  "nav.partnerReport": "Báo cáo đối tác",
  "nav.appLinks": "Liên kết ứng dụng",
  "nav.shopIntegrationCards": "Hiển thị tích hợp cho khách",
  "nav.customerWorkspaces": "Không gian khách hàng",
  "nav.customerUsers": "Người dùng",
  "nav.invoiceQuota": "Lượt hoá đơn",
  "nav.resale": "Bán lại dịch vụ",
  "nav.acquisitionOps": "Máy chủ lấy hóa đơn VN",

  attentionNone: "Không có mục nào cần xử lý",
  attentionCount: "{count} mục chưa giải quyết — gồm cả mục đã ghi nhận",
  logout: "Đăng xuất",
  appStatusTitle: "{app} — {status}",
  appNotLive: "Nguồn chưa nối",
  language: "Ngôn ngữ",

  "theme.menu": "Giao diện",
  "theme.light": "Sáng",
  "theme.dark": "Tối",
  "theme.studio": "Studio",
  "theme.retro": "Retro",
  "theme.system": "Theo hệ thống",
  "theme.lightAbbr": "Sáng",
  "theme.darkAbbr": "Tối",
  "theme.studioAbbr": "Stu",
  "theme.retroAbbr": "Ret",
  "theme.systemAbbr": "HT",

  sessionUnreachable: "Không kết nối được máy chủ của Bube HQ. Đây là lỗi mạng hoặc máy chủ — không phải phiên đăng nhập.",
  sessionRetry: "Thử lại",
  sessionChecking: "Đang kiểm tra phiên…",

  searchPlaceholder: "Tìm sản phẩm hoặc dịch vụ…",
  searchAria: "Tìm trong danh mục",
  searchEmpty: "Không có mục nào khớp. Danh mục nạp từ mã nguồn — thứ chưa khai thì chưa tìm được.",
  searchProduct: "sản phẩm · {slug}",
  searchService: "dịch vụ · {slug}",
} as const;
